import { render, staticRenderFns } from "./TableCreation.vue?vue&type=template&id=3cd64af0&scoped=true"
import script from "./TableCreation.vue?vue&type=script&lang=js"
export * from "./TableCreation.vue?vue&type=script&lang=js"
import style0 from "./TableCreation.vue?vue&type=style&index=0&id=3cd64af0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd64af0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd64af0')) {
      api.createRecord('3cd64af0', component.options)
    } else {
      api.reload('3cd64af0', component.options)
    }
    module.hot.accept("./TableCreation.vue?vue&type=template&id=3cd64af0&scoped=true", function () {
      api.rerender('3cd64af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/TableCreation.vue"
export default component.exports